/* ============================================================
   BEAUTY BAR — Theme JavaScript
   ============================================================ */

   (function () {
    'use strict';
  
  /* ── Confetti Engine ── */
  // Only show confetti on home page
  const isHomePage = document.body.dataset.pageTemplate === 'index' || 
                     window.location.pathname === '/' || 
                     window.location.pathname === '/index';
  
  const canvas = document.getElementById('confetti-canvas');
  if (canvas && isHomePage) {
      const ctx = canvas.getContext('2d');
      const COLORS = [
        '#E8A0B0','#C4607A','#F5D0DA','#E8537A',
        '#FADADD','#C9A96E','#E2C898','#FAE8ED',
        '#FF85A1','#FFB3C6','#FFC8D8'
      ];
  
      function resize() {
        canvas.width  = window.innerWidth;
        canvas.height = window.innerHeight;
      }
      resize();
      window.addEventListener('resize', resize);
  
      class Particle {
        constructor(burst) {
          this.reset(burst);
        }
        reset(burst) {
          this.x       = burst ? canvas.width * Math.random() : Math.random() * canvas.width;
          this.y       = burst ? canvas.height * 0.4 * Math.random() : -14;
          this.size    = 4 + Math.random() * 8;
          this.color   = COLORS[Math.floor(Math.random() * COLORS.length)];
          this.speedX  = (Math.random() - 0.5) * (burst ? 8 : 2.5);
          this.speedY  = burst ? (-6 - Math.random() * 8) : (1.5 + Math.random() * 3);
          this.gravity = burst ? 0.25 : 0.02;
          this.rot     = Math.random() * Math.PI * 2;
          this.rotSpd  = (Math.random() - 0.5) * 0.15;
          this.shape   = Math.random() > 0.5 ? 'rect' : 'circle';
          this.opacity = 1;
          this.fade    = burst ? 0.012 : 0.05;
          this.alive   = true;
        }
        update() {
          this.x       += this.speedX;
          this.y       += this.speedY;
          this.speedY  += this.gravity;
          this.speedX  *= 0.99;
          this.rot     += this.rotSpd;
          this.opacity -= this.fade;
          if (this.opacity <= 0 || this.y > canvas.height + 20) this.alive = false;
        }
        draw() {
          ctx.save();
          ctx.globalAlpha = Math.max(0, this.opacity);
          ctx.translate(this.x, this.y);
          ctx.rotate(this.rot);
          ctx.fillStyle = this.color;
          if (this.shape === 'rect') {
            ctx.fillRect(-this.size / 2, -this.size / 4, this.size, this.size / 2);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, this.size / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        }
      }
  
      let particles = [];
      let drizzleActive = true;
  
      window.BB = window.BB || {};
      window.BB.burst = function () {
        for (let i = 0; i < 120; i++) particles.push(new Particle(true));
      };
  
      function drizzle() {
        if (drizzleActive && Math.random() < 0.35) particles.push(new Particle(false));
      }
  
      function loop() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        drizzle();
        particles = particles.filter(p => p.alive);
        particles.forEach(p => { p.update(); p.draw(); });
        requestAnimationFrame(loop);
      }
  
      setTimeout(() => window.BB.burst(), 400);
      setTimeout(() => window.BB.burst(), 1200);
      loop();
      setTimeout(() => { drizzleActive = false; }, 12000);
    }
  
    /* ── Countdown ── */
    function initCountdown() {
      const el = document.querySelector('[data-countdown]');
      if (!el) return;
      const target = new Date(el.dataset.countdown);
  
      function tick() {
        let diff = Math.max(0, target - new Date());
        const d = Math.floor(diff / 86400000); diff -= d * 86400000;
        const h = Math.floor(diff / 3600000);  diff -= h * 3600000;
        const m = Math.floor(diff / 60000);    diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        const set = (id, v) => { const n = document.getElementById(id); if (n) n.textContent = String(v).padStart(2, '0'); };
        set('cd-d', d); set('cd-h', h); set('cd-m', m); set('cd-s', s);
      }
      tick();
      setInterval(tick, 1000);
    }
    initCountdown();
  
    /* ── Scroll Reveal ── */
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  
    /* ── Cart count ── */
    function getCart() {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        document.querySelectorAll('.cart-badge').forEach(b => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
    }
    getCart();
  
    /* ── Add to Cart ── */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
      if (!variantId) return;
  
      const origText = btn.textContent;
      btn.textContent = '✓';
      btn.disabled = true;
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        getCart();
        if (window.BB && window.BB.burst) window.BB.burst();
        setTimeout(() => { btn.textContent = origText; btn.disabled = false; }, 1400);
      })
      .catch(() => { btn.textContent = origText; btn.disabled = false; });
    });
  
    /* ── Wishlist toggle (visual only — extend with customer metafields if needed) ── */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      const liked = btn.dataset.liked === '1';
      const path  = btn.querySelector('path');
      if (path) {
        path.style.fill   = liked ? 'none' : 'var(--rose-deep)';
        path.style.stroke = liked ? 'var(--rose-deep)' : 'var(--rose-deep)';
      }
      btn.dataset.liked = liked ? '0' : '1';
    });
  
    /* ── Nav drawer ── */
    const drawer  = document.getElementById('nav-drawer');
    const overlay = drawer?.querySelector('.nav-drawer__overlay');
    const closeBtn = drawer?.querySelector('.nav-drawer__close');
  
    document.querySelectorAll('[data-open-nav]').forEach(btn => {
      btn.addEventListener('click', () => drawer?.classList.add('open'));
    });
    overlay?.addEventListener('click', () => drawer?.classList.remove('open'));
    closeBtn?.addEventListener('click', () => drawer?.classList.remove('open'));
  
    /* ── Product page thumb gallery ── */
    document.querySelectorAll('.product-page__thumb').forEach(thumb => {
      thumb.addEventListener('click', function () {
        const src = this.dataset.src || this.src;
        const main = document.querySelector('.product-page__main-img');
        if (main) main.src = src;
        document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  
    /* ── Variant selection ── */
    document.querySelectorAll('.product-page__variant-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        this.closest('.product-page__variants').querySelectorAll('.product-page__variant-btn')
          .forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        const form = document.querySelector('form[action="/cart/add"]');
        if (form) {
          const input = form.querySelector('[name="id"]');
          if (input) input.value = this.dataset.variantId;
        }
      });
    });
  
    /* ── Cart qty update ── */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const key   = btn.dataset.key;
      const delta = parseInt(btn.dataset.qtyChange);
      const qtyEl = btn.closest('.cart-item')?.querySelector('[data-qty]');
      const cur   = parseInt(qtyEl?.textContent || '1');
      const next  = Math.max(0, cur + delta);
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
      .then(r => r.json())
      .then(() => { location.reload(); });
    });
  
    /* ── Mystery box tier selection ── */
    document.querySelectorAll('.mystery-box__tier').forEach(tier => {
      tier.addEventListener('click', function () {
        document.querySelectorAll('.mystery-box__tier').forEach(t => {
          t.style.borderColor = '';
          t.style.background  = '';
        });
        this.style.borderColor = 'var(--rose)';
        this.style.background  = 'rgba(232,160,176,0.1)';
        const variantId = this.dataset.variantId;
        const form = document.querySelector('#mystery-box-form [name="id"]');
        if (form && variantId) form.value = variantId;
      });
    });
  
  })();
  
  /* ── ADDED IN V2-FIXED ── */
  (function() {
  
    /* NAV — fix for mobile (ids instead of class queries) */
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-overlay');
    var navClose   = document.getElementById('nav-close');
    if (navDrawer) {
      function openNav()  { navDrawer.classList.add('open');    document.body.style.overflow='hidden'; }
      function closeNav() { navDrawer.classList.remove('open'); document.body.style.overflow=''; }
      document.querySelectorAll('[data-open-nav]').forEach(function(b){ b.addEventListener('click', openNav); });
      if (navOverlay) navOverlay.addEventListener('click', closeNav);
      if (navClose)   navClose.addEventListener('click', closeNav);
      document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeNav(); closeSearch(); } });
      navDrawer.querySelectorAll('.nav-link').forEach(function(l){ l.addEventListener('click', closeNav); });
    }
  
    /* SEARCH */
    var searchOverlay = document.getElementById('search-overlay');
    var searchOpen    = document.getElementById('search-open');
    var searchBackdrop= document.getElementById('search-backdrop');
    var searchClose   = document.getElementById('search-close');
    var searchInput   = document.getElementById('search-input');
    var searchResults = document.getElementById('search-results');
    var searchTimer   = null;
  
    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function(){ if(searchInput) searchInput.focus(); }, 120);
    }
    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (searchOpen)    searchOpen.addEventListener('click', openSearch);
    if (searchBackdrop)searchBackdrop.addEventListener('click', closeSearch);
    if (searchClose)   searchClose.addEventListener('click', closeSearch);
  
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimer);
        var q = searchInput.value.trim();
        if (!searchResults) return;
        if (q.length < 2) { searchResults.innerHTML = ''; return; }
        searchTimer = setTimeout(function() {
          fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
            .then(function(r){ return r.json(); })
            .then(function(data) {
              var products = (data&&data.resources&&data.resources.results&&data.resources.results.products)||[];
              if (!products.length) {
                searchResults.innerHTML = '<div class="search-overlay__empty">No results — <a href="/search?q='+encodeURIComponent(q)+'&type=product">See all</a></div>';
                return;
              }
              searchResults.innerHTML = products.map(function(p) {
                var img = (p.featured_image&&p.featured_image.url) ? p.featured_image.url+'&width=88' : '';
                var price = p.price ? 'EGP '+Math.round(parseInt(p.price)/100).toLocaleString() : '';
                return '<a href="'+p.url+'" class="search-overlay__item">'+
                  (img?'<img src="'+img+'" alt="" class="search-overlay__item-img" onerror="this.style.display=\'none\'">':'<div class="search-overlay__item-img"></div>')+
                  '<div><div class="search-overlay__item-title">'+p.title+'</div>'+
                  '<div class="search-overlay__item-price">'+price+'</div></div></a>';
              }).join('');
            })
            .catch(function(){
              searchResults.innerHTML = '<div class="search-overlay__empty"><a href="/search?q='+encodeURIComponent(q)+'&type=product">Search for "'+q+'"</a></div>';
            });
        }, 300);
      });
      searchInput.addEventListener('keydown', function(e){
        if (e.key==='Enter') { e.preventDefault(); var q=searchInput.value.trim(); if(q) window.location.href='/search?q='+encodeURIComponent(q)+'&type=product'; }
      });
    }
  
    /* PDP ENHANCEMENTS */
    if (document.querySelector('.product-page')) {
  
      /* Sticky bar */
      var stickyBar = document.getElementById('pdp-sticky');
      var atcBtn    = document.getElementById('pdp-atc');
      if (stickyBar && atcBtn && window.IntersectionObserver) {
        new IntersectionObserver(function(entries){
          stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
        },{threshold:0}).observe(atcBtn);
      }
      var stickyBtn = document.getElementById('pdp-sticky-btn');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function(){
          var form = document.getElementById('pdp-form');
          if (form) form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
        });
      }
  
      /* Qty */
      var qty = 1;
      var qtyDisplay = document.getElementById('qty-display');
      var qtyInput   = document.getElementById('pdp-qty');
      var buyNowBtn = document.getElementById('pdp-buy-now');
      var updateBuyNowHref = function() {
        if(buyNowBtn) {
          var varId = document.getElementById('pdp-variant-id');
          if(varId && varId.value) {
            buyNowBtn.href = '/cart/add?id='+varId.value+'&quantity='+qty+'&return_to=/checkout';
          }
        }
      };
      document.getElementById('qty-minus') && document.getElementById('qty-minus').addEventListener('click', function(){
        if(qty>1){qty--; if(qtyDisplay)qtyDisplay.textContent=qty; if(qtyInput)qtyInput.value=qty; updateBuyNowHref();}
      });
      document.getElementById('qty-plus') && document.getElementById('qty-plus').addEventListener('click', function(){
        if(qty<10){qty++; if(qtyDisplay)qtyDisplay.textContent=qty; if(qtyInput)qtyInput.value=qty; updateBuyNowHref();}
      });
  
      /* Variant buttons update price display */
      document.querySelectorAll('.product-page__variant-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          document.querySelectorAll('.product-page__variant-btn').forEach(function(b){b.classList.remove('active');});
          btn.classList.add('active');
          var varId = document.getElementById('pdp-variant-id');
          if(varId) varId.value = btn.dataset.variantId;
          var priceEl = document.getElementById('pdp-price');
          if(priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
          var nameEl = document.getElementById('pdp-variant-name');
          if(nameEl) nameEl.textContent = btn.textContent.trim();
          var buyNow = document.getElementById('pdp-buy-now');
          if(buyNow) {
            var currentQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
            buyNow.href = '/cart/add?id='+btn.dataset.variantId+'&quantity='+currentQty+'&return_to=/checkout';
          }
          if(btn.dataset.available==='false'){
            if(atcBtn){atcBtn.disabled=true; atcBtn.textContent='Sold Out';}
          } else {
            if(atcBtn){atcBtn.disabled=false; atcBtn.textContent='Add to Bag';}
          }
        });
      });
  
      /* AJAX ATC form */
      var pdpForm = document.getElementById('pdp-form');
      if (pdpForm) {
        pdpForm.addEventListener('submit', function(e){
          e.preventDefault();
          var varId = document.getElementById('pdp-variant-id');
          var qtyVal = document.getElementById('pdp-qty');
          if(!varId) return;
          var btn = document.getElementById('pdp-atc');
          if(btn&&btn.disabled) return;
          if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
          fetch('/cart/add.js',{
            method:'POST', headers:{'Content-Type':'application/json'},
            body:JSON.stringify({id:varId.value, quantity:parseInt((qtyVal&&qtyVal.value)||1)})
          }).then(function(r){return r.json();}).then(function(){
            if(btn){ btn.textContent='✓ Added'; }
            fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
              document.querySelectorAll('.cart-badge').forEach(function(b){b.textContent=c.item_count;b.style.display=c.item_count>0?'flex':'none';});
            });
            if(window.BB&&window.BB.burst) window.BB.burst();
            setTimeout(function(){ if(btn){btn.disabled=false;btn.textContent='Add to Bag';} },2200);
          }).catch(function(){ if(btn){btn.disabled=false;btn.textContent='Add to Bag';} });
        });
      }
  
      /* Accordions */
      document.querySelectorAll('.pdp-accord__btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.dataset.accord;
          var body = document.getElementById('accord-'+key);
          var wasOpen = btn.classList.contains('open');
          document.querySelectorAll('.pdp-accord__btn').forEach(function(b){b.classList.remove('open');});
          document.querySelectorAll('.pdp-accord__body').forEach(function(b){b.classList.remove('open');});
          if(!wasOpen&&body){ btn.classList.add('open'); body.classList.add('open'); }
        });
      });
  
      /* Urgency counter */
      var viewersEl = document.getElementById('pdp-viewers');
      if(viewersEl){
        var base = parseInt((viewersEl.textContent.match(/\d+/)||['12'])[0],10);
        setInterval(function(){
          base = Math.max(4, base + Math.floor(Math.random()*3)-1);
          viewersEl.textContent = '🔥 '+base+' people viewing this now';
        },8000);
      }
  
      /* Recently Viewed */
      (function(){
        var titleEl = document.querySelector('.product-page__title');
        var imgEl   = document.getElementById('main-product-img');
        var priceEl = document.getElementById('pdp-price');
        if(!titleEl) return;
        var KEY='bb_rv', viewed=[];
        try{viewed=JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){}
        var cur={title:titleEl.textContent.trim(),img:imgEl?imgEl.src:'',url:window.location.pathname,price:priceEl?priceEl.textContent.trim():''};
        viewed=viewed.filter(function(p){return p.url!==cur.url;});
        viewed.unshift(cur); viewed=viewed.slice(0,8);
        try{localStorage.setItem(KEY,JSON.stringify(viewed));}catch(e){}
        var others=viewed.slice(1);
        var section=document.getElementById('pdp-recently');
        var row=document.getElementById('pdp-recently-row');
        if(others.length>0&&section&&row){
          row.innerHTML=others.slice(0,4).map(function(p){
            return '<div class="pdp-upsell__card"><div class="pdp-upsell__img-wrap"><a href="'+p.url+'"><img src="'+p.img+'" alt="" loading="lazy" class="pdp-upsell__img"></a></div>'+
              '<a href="'+p.url+'" class="pdp-upsell__name">'+p.title.substring(0,30)+'</a>'+
              '<div><span class="pdp-upsell__price">'+(p.price||'')+'</span></div></div>';
          }).join('');
          section.style.display='';
        }
      })();
    }
  
  })();
  